
import axios from '@/axios.js'

export default {
  // TASK
    fetchLaporan ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/task-list-page', payload)
          .then((response) => {
            commit('SET_LAPORANS', response.data.data.tasks)
            commit('SET_TOTALS', response.data.data.total)
            commit('SET_LAST', response.data.data.last_page)
            commit('SET_PER_PAGE', response.data.data.per_page)
            commit('SET_CURRENT_PAGE', response.data.data.current_page)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },

    addUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/task-add', data)
        .then((response) => {
          commit('ADD_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    editUpdate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        //axios.post('/task-update-add', data)
        axios.post('/task-update', data)
        .then((response) => {
          commit('EDIT_UPDATE', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    removeLaporan ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.delete(`/task-delete/${data.parent}`)
        .then((response) => {
          commit('REMOVE_LAPORAN', data.id)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    restoreLaporan ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/task-restore/${data.parent}`)
        .then((response) => {
          commit('REMOVE_LAPORAN', data.id)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },
  
  // TIPE
    fetchKategori ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`/term-list/laporan`)
          .then((response) => {
            commit('SET_KATEGORIS', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    }

}
